(function($){

	var throttle = function( fn, wait ){
		var time = Date.now();
		return function(){
			if( ( time + wait - Date.now() ) < 0 ){
				fn();
				time = Date.now();
			}
		};
	};

	var closeMenusOnResize = function(){
		$( 'body' ).removeClass( 'nav-open' );
		$( 'li.menu-item-open' ).removeClass( 'menu-item-open' );
	};

	var destinationGrid = function(){
		$( '.magnific-grid' ).magnificPopup({
			type:'image',
			gallery: {
				arrowMarkup: '<a title="%title%" href="javascript:void(0);" class="mfp-arrow mfp-arrow-%dir%"></a>',
				enabled: true,
			}
		});
	};

	var destinationSlider = function(){
		$( '.destination-section-slider' ).slick({
			adaptiveHeight: true,
			autoplay: true,
			autoplaySpeed: 5000,
			nextArrow: '<a href="#" title="Next Slide" class="slick-arrow slider-next"></a>',
			prevArrow: '<a href="#" title="Previous Slide" class="slick-arrow slider-prev"></a>'
		});
	};

	var doShortcodeSlideshow = function(){
		$( '.msw-single-slideshow' ).slick({
			nextArrow: '<a href="#" title="Next Slide" class="slick-arrow slider-next"></a>',
			prevArrow: '<a href="#" title="Previous Slide" class="slick-arrow slider-prev"></a>'
		});
	};

	/*
	var doTrackAds = function(){
		$( '.adtab' ).each( function( ev ){
			var data = {
				'action' : 'msw_track_views',
				'adid' : $( this ).data( 'adid' )
			};
			$.post( MSWObject.ajax_url, data, function( response ){
			}, 'json' );
		});
		$( 'body' ).on( 'click', '.admob, .adtab', function( ev ){
			ev.preventDefault();
			var adid = $( this ).data( 'adid' );
			ga( 'send', 'event', {
				eventCategory: 'Ad Click',
				eventAction: 'click',
				eventLabel: adid,
				transport: 'beacon'
			} );
			ga( 'msw.send', 'event', {
				eventCategory: 'Ad Click',
				eventAction: 'click',
				eventLabel: adid,
				transport: 'beacon'
			} );
			console.log( ev.target.href );

			var data = {
				'action' : 'msw_track_clicks',
				'adid' : $( this ).data( 'adid' )
			};
			$.post( MSWObject.ajax_url, data, function( response ){
			}, 'json' );
		});
	};
	*/

	var eventsSubmitDatepickers = function(){
		if( $( '.event-start-date' ).length ){
			$( '.datepicker' ).datepicker({
				dateFormat: "mm/dd/yy",
				minDate: new Date(),
				onSelect: function( date ){
					var selectedDate = new Date(date);
					selectedDate = $("input[name=input_36]").val();
					$("input[name=input_37]").datepicker( "option", "minDate", selectedDate );
				}
			});
		}
	};

	var frontSlider = function(){
		if( $( '.front-slider' ).length ){
			$( '.front-slider.center' ).slick({
				autoplay: true,
				autoplaySpeed: 5000,
				centerMode: true,
				centerPadding: '0',
				nextArrow: '.slider-next',
				prevArrow: '.slider-prev',
				slidesToShow: 3,
				//asNavFor: '.front-slider.left, .front-slider.right'
				responsive: [
					{
						breakpoint: 767,
						settings: {
							//arrows: false,
							centerMode: true,
							centerPadding: '0',
							slidesToShow: 1
						}
					}
				]
			});
			/*$( '.front-slider.center' ).slick({
				autoplay: false,
				autoplaySpeed: 5000,
				centerMode: true,
				centerPadding: '0',
				nextArrow: '<a href="#" title="Next Slide" class="next"></a>',
				prevArrow: '<a href="#" title="Previous Slide" class="prev"></a>',
				slidesToShow: 3
			});*/
			/*$( '.front-slider.left, .front-slider.right' ).slick({
				autoplay: false,
				autoplaySpeed: 5000,
				arrows: false
			});*/
		}
	};

	var eventsCalculation = function(){
		if( $( '.event_form_calculation_custom' ).length ){
			gform.addFilter( 'gform_calculation_result', function( result, formulaField, formId, calcObj ){
				return Math.max(0,result);
			} );
		}
	};

	var eventsSlider = function(){
		if( $( '.home-events-slider' ).length ){
			$( '.home-events-slider' ).slick({
				//adaptiveHeight: true,
				autoplay: true,
				autoplaySpeed: 5000,
				nextArrow: '.next-event',
				prevArrow: '.prev-event',
				infinite: false
			});
		}
	};

	var magnificModal = function(){
		$( '.magnific-modal' ).magnificPopup({
			type: 'inline'
		});
		$( '.gallery-item a' ).each(function(){
			var src = $(this).children( 'img' ).attr( 'src' );
			$( this ).attr( 'href', src );
		});
		$( '.gallery-item a' ).magnificPopup({
			type: 'image',
			gallery: {
				enabled: true
			}
		});

		/*$('.magnific-addevent').magnificPopup({
			type: 'ajax',
			callbacks: {
				parseAjax: function(mfpResponse) {
					// mfpResponse.data is a "data" object from ajax "success" callback
					// for simple HTML file, it will be just String
					// You may modify it to change contents of the popup
					// For example, to show just #some-element:
					mfpResponse.data = $(mfpResponse.data).find('#tribe-community-events');

					// mfpResponse.data must be a String or a DOM (jQuery) element

					//console.log('Ajax content loaded:', mfpResponse);
				},
				ajaxContentAdded: function() {
					// Ajax content is loaded and appended to DOM
					//console.log(this.content);
				}
			}
		});*/
	};

	var recipeFiltersToggle = function(){
		$( '.recipe-filters-toggle' ).click(function(ev){
			ev.preventDefault();
			$( '#filterform' ).toggle();
		});
	};

	var stickSocial = function(){
		var containerHeight, headerHeight, columnHeight, extraPadding, socialShareHeight, columnOffset, start, stop, windowScroll;
		if( $( '.side-share' ).length && $( '.side-share' ).is( ':visible' ) ){
			var resetHeights = function(){
				headerHeight = $( '.site-header' ).outerHeight();
				columnHeight = $( '.side-share' ).height();
				socialShareHeight = $( '.side-share .inner' ).height();
				columnOffset = $( '.side-share' ).offset();
				containerHeight = $( '.side-share' ).closest( '.container' ).height();
				start = columnOffset.top - headerHeight + parseInt( $( '.side-share' ).css('padding-top') );
				stop = containerHeight;
				windowScroll = window.pageYOffset || document.documentElement.scrollTop;
				extraPadding = parseInt( window.getComputedStyle( document.documentElement ).getPropertyValue( 'font-size' ) ) || 16;
			};
			resetHeights();
			optimizedResize.add( resetHeights );

			var doStick = function(){
				headerHeight = $( '.site-header' ).outerHeight();
				columnOffset = $( '.side-share' ).offset();
				start = columnOffset.top - headerHeight + parseInt( $( '.side-share' ).css('padding-top') );
				windowScroll = window.pageYOffset || document.documentElement.scrollTop;
				var paddingTop = windowScroll - start + extraPadding;
				if( windowScroll < start ){
					$( '.side-share .inner' ).removeAttr( 'style' );
				} else if( windowScroll > stop ){
					//do nothing
				} else {
					$( '.side-share .inner' ).css({'transform': 'translate(0px,' + paddingTop + 'px)'});
				}
			};
			doStick();
			window.addEventListener('scroll', throttle(doStick, 100));
		}
	};

	var toggleLeaf = function(){
		$( document ).click( function( ev ){
			if( !$( ev.target ).closest( '.email-leaf' ).length ){
				$( 'body' ).removeClass( 'leaf-open' );
			}
		} );
		$( '.email-leaf-toggle' ).on( 'click', function( ev ){
			ev.preventDefault();
			if( $( 'body' ).hasClass( 'nav-open' ) ){
				$( 'body' ).removeClass( 'nav-open' );
			}
			$( 'body' ).toggleClass( 'leaf-open' );
		});
	};

	var eventForm = function(){
		if ( $( '#gform_wrapper_40' ).length ){
			// $( '.select2-choices' ).find( 'select' ).select2();
			// $( '.select2-drop' ).find( 'select' ).select2();

			$(".event-all-day").find( 'input' ).change(function() {
			    if(this.checked) {
			       $( '.event-time' ).addClass( 'not-active' );
			    } else {
			    	$( '.event-time' ).removeClass( 'not-active' );
			    }
			});
		}
	};

	var eventsMods = function(){

		if($('.tribe-community-events.form').length > 0){
			$('#EventShowMap, #EventShowMapLink').prop('checked', true);
			$('#google_map_toggle, #google_map_link_toggle').css('display', 'none');
			$('#StateProvinceSelect option[value="KY"]').prop('selected', true);
		}

		$('.tribe-events-meta-group .tribe-venue > a, .tribe-events-meta-group .tribe-organizer > a').on('click', function(e){
			e.preventDefault();
		});
	};

	var searchModal = function(){
		$('[data-action="search-modal"]').magnificPopup({
			type: 'inline',
			preloader: false,
			focus: '#search-input',
			callbacks: {
				beforeOpen: function() {
					$( 'body' ).removeClass( 'nav-open' );
					$( 'li.menu-item-open' ).removeClass( 'menu-item-open' );

					if($(window).width() < 700) {
						this.st.focus = false;
					} else {
						this.st.focus = '#search-input';
					}
				}
			}
		});
		$(document).on('click', '.search-modal-close', function (e) {
			e.preventDefault();
			$.magnificPopup.close();
		});
		//$('[data-action="search-modal"]').on('click', function(){
		//	$('#search-modal').addClass('vis');
		//});
		//$('.search-modal-close').on('click', function(){
		//	$('#search-modal').removeClass('vis');
		//});
	}

	$(document).ready(function(){
		destinationGrid();
		destinationSlider();
		eventForm();
		//doTrackAds();
		stickSocial();
		frontSlider();
		doShortcodeSlideshow();
		toggleLeaf();
		eventsCalculation();
		eventsSubmitDatepickers();
		eventsSlider();
		magnificModal();
		recipeFiltersToggle();
		optimizedResize.add( closeMenusOnResize );
		searchModal();


		$('.tribe-events-sub-nav a').on('click', function (e) {
			console.log('wellll');
			e.stopPropagation();
		})
	});
	$( window ).load(function() {
		eventsMods();
	});
})(jQuery);